import { useMerchant } from 'hooks/useGlobalContext/useMerchant'
import React, { useEffect, useState } from 'react'
import { LoaderProps } from './types'
import { GET_MERCHANT_CATEGORIES } from 'router/queries'
import { useSession } from 'packages/@slerp/accounts'
import { useLazyQuery } from '@apollo/client'
import { MerchantCategory } from '@slerp/controls'

export const MerchantCategoriesLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const { merchant } = useSession()
  const {
    merchantCategories,
    archivedMerchantCategories,
    setMerchantCategories,
    setArchivedMerchantCategories,
    setRefetchCategories
  } = useMerchant()

  const [isLoaded, setIsLoaded] = useState(false)

  const [getMerchantCategories, { data, loading, refetch }] = useLazyQuery(
    GET_MERCHANT_CATEGORIES,
    {
      variables: { merchantId: merchant?.id }
    }
  )

  useEffect(() => {
    if (
      !merchant?.id ||
      (!!merchantCategories.length && !!archivedMerchantCategories.length)
    ) {
      return
    }

    getMerchantCategories()
  }, [merchant?.id])

  useEffect(() => {
    if (!refetch) {
      return
    }

    setRefetchCategories(() => refetch)
  }, [refetch])

  useEffect(() => {
    if (data?.categories) {
      setMerchantCategories(
        data.categories.filter(
          (category: MerchantCategory) => !category.archived_at
        )
      )
      setArchivedMerchantCategories(
        data.categories.filter(
          (category: MerchantCategory) => !!category.archived_at
        )
      )
    }
  }, [data])

  useEffect(() => {
    setIsLoaded(isParentLoaded && !loading)
  }, [loading, isParentLoaded])

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
